import { RULER_BAR_SIZE } from '../constants';

interface IActiveLayerRulerRectOptions {
    left: number;
    top: number;
    width: number;
    height: number;
    frameOffsetTop: number;
    scale: number;
    translateX: number;
    translateY: number;
}

/** 将图层的画布内坐标转换为标尺容器内的高亮区域。 */
export function getActiveLayerRulerRect({
    left,
    top,
    width,
    height,
    frameOffsetTop,
    scale,
    translateX,
    translateY,
}: IActiveLayerRulerRectOptions) {
    return {
        left: translateX + left * scale - RULER_BAR_SIZE,
        top: translateY + (frameOffsetTop + top) * scale - RULER_BAR_SIZE,
        width: width * scale,
        height: height * scale,
    };
}
